import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { ObjectTypeInfo, PageBase, T4PricelistInfo, T4PriceListInterval } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { saveAs } from 'file-saver';
@Component({
  styleUrls: ['./pricelist.css'],
  selector: 'pricelist',
  templateUrl: './pricelist.component.html',
})
export class PriceListComponent extends PageBase implements OnInit {
  public pricelist: T4PricelistInfo;
  public objectTypes: ObjectTypeInfo[] = [];
  public childId: Number;

  @ViewChild("txtTitle") private txtTitle: NgModel;
  @ViewChild("txtValidFrom") private txtValidFrom: NgModel;

  public isValid(): boolean {
    return this.txtTitle && this.txtValidFrom && this.txtTitle.valid && this.txtValidFrom.valid;
  }

  public numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  @ViewChild("tblIntervals")
  private tblIntervals: T4DatatableWidget;

  @ViewChild("tblPrices")
  private tblPrices: T4DatatableWidget;

  constructor(el: ElementRef, private route: ActivatedRoute) {
      super(el, "Settings");
    }

  async ngOnInit() {
    var token = this.UI.beginLoading("T4.Settings.Pricelist.msgLoading", "Loading pricelist", null);
    this.route.params.subscribe(async params => {
      if (params.ChildId) {
        this.childId = params.ChildId;
      }
      this.pricelist = await this.Api.get<T4PricelistInfo>("Settings/GetPricelistInfo", { id: +params.Id, childId: this.childId });
      
      if (!this.pricelist.Prices) this.pricelist.Prices = [];
      if (!this.pricelist.Intervals) this.pricelist.Intervals = [];

      if (this.childId) {
        this.objectTypes = await this.Api.get<ObjectTypeInfo[]>("RentalObject/GetChildTypes", { type: this.pricelist.Type, childId: this.childId });
      }
      else {
        this.objectTypes = await this.Api.get<ObjectTypeInfo[]>("RentalObject/GetTypes", { type: this.pricelist.Type });
      }
      
      this.objectTypes.sort((a, b) => (a.Title < b.Title) ? -1 : 1);

      // Add any other types that has prices set
      for (var x of this.pricelist.Prices) {
        if (!this.objectTypes.some(y => y.Id == x.ObjectTypeId)) {
          var t = await this.Api.get<ObjectTypeInfo>("RentalObject/GetTypeInfo", { objectType: x.ObjectTypeId });
          this.objectTypes.push(t);
        }
      }
      
      if(this.tblIntervals) this.tblIntervals.update();
      if (this.tblPrices)  this.tblPrices.update(true);
      this.UI.loaderCompleted(token);
    });
  }
  public addInterval() {
    var maxInterval = this.pricelist.Intervals.length - 1;
    if (maxInterval >= 0) maxInterval = this.pricelist.Intervals[maxInterval].Interval;
    else maxInterval = 0;

    this.pricelist.Intervals.push({ Id: maxInterval + 1, PriceListId: 1, Interval: maxInterval + 1, Unit: null, IsBaseInterval: false });
    this.pricelist.Intervals.sort((a, b) => a.Interval < b.Interval ? -1 : 1);
    if (this.tblIntervals) this.tblIntervals.update();
    if (this.tblPrices) this.tblPrices.update(true);
  }

  public async deleteInterval(interval: T4PriceListInterval) {
    if (await this.UI.confirm("T4.Settings.Pricelist.headConfirmRemoveInterval", "Confirm removal of interval", "T4.Settings.Pricelist.msgConfirmRemoveInterval", "Do you want to remove this interval? All prices will be lost.")) {
      this.pricelist.Intervals.splice(this.pricelist.Intervals.indexOf(interval), 1);
      if (this.tblIntervals) this.tblIntervals.update();
      if (this.tblPrices) this.tblPrices.update(true);
    }
  }


  public GetPrice(objectTypeId: number, intervalId: number): number {
    var price = this.pricelist.Prices.find(x => x.ObjectTypeId == objectTypeId && x.IntervalId == intervalId);

    if (price) return price.Price;

    return null;
  }

  public SetPrice(objectTypeId: any, intervalId: number, value: string)
  {
    var price = this.pricelist.Prices.find(x => x.ObjectTypeId == objectTypeId && x.IntervalId == intervalId);
    
    if (value == "") {
      if (price) {
        this.pricelist.Prices.splice(this.pricelist.Prices.indexOf(price), 1);
        return;
      }
    } else {
      if (!price) {
        this.pricelist.Prices.push({ IntervalId: intervalId, ObjectTypeId: objectTypeId, Price: parseInt(value), PriceListId: this.pricelist.Id, ObjectType: null })
      } else {
        price.Price = parseInt(value);
      }
    }
  }

  public setBaseInterval(i: T4PriceListInterval) {
    this.pricelist.Intervals.map(x => x.IsBaseInterval = false);
    i.IsBaseInterval = true;
  }

  public async save() {
    var token = this.UI.beginLoading("T4.Settings.Pricelist.msgSaving", "Saving pricelist", null);
    await this.Api.post("Settings/SavePricelist", this.pricelist, { childId: this.childId });
    this.UI.loaderCompleted(token);
    //this.UI.alert("T4.Settings.Pricelist.headSaved", "Pricelist saved!", "T4.Settings.Pricelist.msgSaved", "The pricelist has been updated.");
  }



  public exportPricelist() {

    //Loops throught the RentalObject, and maps the prices for each interval.
    const mappedExcelObject = this.objectTypes.map(x => {
      const intervalPrices = {};
      this.pricelist.Prices.filter(price => price.ObjectTypeId === x.Id).forEach(price => {
        const intervals = this.pricelist.Intervals.filter(interval => interval.Id === price.IntervalId);
        intervals.forEach(interval => {
          intervalPrices[`Interval-${interval.Interval}`] = price.Price;
        });
      });

      // Create a new object with the desired properties
      const newObj = {
        Id: x.Id,
        Name: x.Title,
        ...intervalPrices
      };

      return newObj;
    });


    var content = "";

    // Iterate over each object in mappedExcelObject to collect headers
    const headers = Array.from(
      mappedExcelObject.reduce((acc, obj) => {
        Object.keys(obj).forEach(key => {
          acc.add(key);
        });
        return acc;
      }, new Set<string>())
    );

    for (var i = 0; i < headers.length; i++)
      content += headers[i] + ';';

    content += "\r\n";

    for (var i = 0; i < mappedExcelObject.length; i++) {
      for (var j = 0; j < headers.length; j++) {
        var val = mappedExcelObject[i][headers[j]];

        if (val !== undefined && val !== null) {
          if (val instanceof Date) {
            content += val.toISOString();
          } else if (val instanceof moment) {
            content += (val as moment.Moment).format("YYYY-MM-DD HH:mm");
          } else if (typeof val === "string") {
            content += "\"" + val.replace(/\r?\n|\r/g, "").replace("\"", "\"\"") + "\"";
          } else if (typeof val === "number") {
            content += val.toString().replace(".", ",");
          } else if (val.toString) {
            content += val.toString();
          }
        }
        content += ";";
      }
      content += "\r\n";
    }

    var blob = new Blob([content.replace(".", ",")], {
      type: "text/csv;charset=utf-8"
    });

    var filename = this.pricelist.Title + "_Pricelist.csv";

    saveAs(blob, filename);
  }

  public importPricelist() {

  }
}
